import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { AlgorithmNodeView } from "@/components/editor/nodeviews/AlgorithmNodeView";

export const AlgorithmBlock = Node.create({
  name: "algorithmBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      caption: { default: "" },
      label: { default: "" },
      lines: { default: [{ indent: 0, keyword: "", text: "", comment: "" }] },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="algorithm-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "algorithm-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AlgorithmNodeView);
  },
});
